// Export als Pillen-Widget – dieselbe Logik wie bisher ExportSteuerung/ExportDropdown
// (CSV, Excel, PDF Tabelle, PDF Bericht; Umfang Ansicht/Alle Daten).

import { DownloadSimple } from '@phosphor-icons/react';
import type { ExportColumn, ExportConfig, ExportStats } from '../../../lib/export/types';
import { exportCsv } from '../../../lib/export/exportCsv';
import { exportXlsx } from '../../../lib/export/exportXlsx';
import { exportPdfReport, exportPdfTable } from '../../../lib/export/exportPdf';
import type { ExportWidget } from './typen';

interface ExportQuelle<T> {
  id: string;
  title: string;
  /** Titel im Widget (z. B. „Termine“) */
  titel: string;
  columns: ExportColumn[];
  data: readonly T[];
  fetchAllData: () => Promise<readonly T[]>;
  stats?: ExportStats;
  /** Umfang „Alle Daten“ gewählt? (Zustand liegt beim Bereich) */
  alleDaten: boolean;
  setAlleDaten: (alle: boolean) => void;
  tooltip?: string;
}

const FORMATE = [
  { id: 'csv', label: 'CSV', unter: 'Kompatibel mit Excel', lauf: exportCsv },
  { id: 'xlsx', label: 'Excel', unter: 'Formatierte XLSX-Datei', lauf: exportXlsx },
  { id: 'pdf-table', label: 'PDF (Tabelle)', unter: 'Schneller Tabellenexport', lauf: exportPdfTable },
  { id: 'pdf-report', label: 'PDF (Bericht)', unter: 'Formatiert mit Statistiken', lauf: exportPdfReport },
] as const;

export function exportWidget<T>(q: ExportQuelle<T>): ExportWidget {
  return {
    id: q.id, typ: 'export', farbe: 'gruen', icon: DownloadSimple, kicker: 'Export', titel: q.titel, unter: 'CSV, Excel oder PDF',
    tooltip: q.tooltip,
    umfang: {
      wert: q.alleDaten ? 'alle' : 'ansicht',
      optionen: [{ wert: 'ansicht', label: `Ansicht (${q.data.length})` }, { wert: 'alle', label: 'Alle Daten' }],
      onChange: w => q.setAlleDaten(w === 'alle'),
    },
    formate: FORMATE.map(f => ({
      id: f.id, label: f.label, unter: f.unter,
      onClick: async () => {
        try {
          const daten = q.alleDaten ? await q.fetchAllData() : q.data;
          const config: ExportConfig = { title: q.title, columns: q.columns, data: [...daten], stats: q.stats };
          f.lauf(config);
        } catch (err: unknown) {
          alert('Export fehlgeschlagen: ' + (err instanceof Error ? err.message : 'Unbekannter Fehler'));
        }
      },
    })),
  };
}
